jQuery(document).ready(function($) {
    
    $(window).load(function() {
    	$.ajax({
	        type: 'POST',
	        url: '/wp-content/themes/aroma/functions/ajax/gdwp_cart_count.php',
	        success: function (output) {
	           $('.header__cart').html(output);
	        }
	    });
    });
    
 
});

